module.exports = __webpack_public_path__ + "img/warning.e9ea5567.svg";